import { Component, computed, inject, input, OnDestroy, OnInit, output, signal, viewChild } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidAssessmentToast } from '../../components/rid-assessment-toast/rid-assessment-toast';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidReadingCountdown } from '../../components/rid-reading-countdown/rid-reading-countdown';
import { RidSegmentedWordCard } from '../../components/rid-segmented-word-card/rid-segmented-word-card';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidSfxDirective } from '../../directives/rid-sfx.directive';
import { ExpressionService } from '../../services/expression-service.service';
import { AudioPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-reading-basis-homework-mode',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidMechanicTitle,
    RidBottomButton,
    RidSegmentedWordCard,
    RidReadingCountdown,
    RidAssessmentToast,
    RidSfxDirective,
  ],
  templateUrl: './rid-reading-basis-homework-mode.html',
  host: {
    class: 'block',
  },
})
export class RidReadingBasisHomeworkMode implements OnInit, OnDestroy {
  private readonly $expressionService = inject(ExpressionService);

  instruction = input.required<string>();
  pause = input.required<number>();
  words = input.required<{ word: string[]; audio: string }[]>();
  pace = input.required<number>();

  index = signal(0);
  word = computed(() => this.words()[this.index()]);
  countdown = viewChild.required<RidReadingCountdown>('countdown');
  card = viewChild.required<RidSegmentedWordCard>('card');
  state = signal<'READING' | 'DONE' | 'ASSESSING'>('READING');
  showCountdown = signal(true);

  finished = output<void>();

  ngOnInit(): void {
    this.$expressionService.setAvailability('CLIENT', true);

    this.pass();
  }

  ngOnDestroy(): void {
    this.$expressionService.setAvailability('CLIENT', false);
  }

  async pass() {
    this.state.set('READING');
    this.showCountdown.set(true);
    await delay(500);

    await this.countdown().countdown(this.pace());
    this.showCountdown.set(false);
    await this.card().pass(this.pace());
    await delay(this.pace());
    await this.card().hide();

    await delay(this.pause());

    this.assess();
  }

  assess() {
    this.state.set('ASSESSING');

    AudioPlayer.play(this.word().audio);
  }

  assessed(correct: boolean) {
    this.next();
  }

  next() {
    if (this.index() >= this.words().length - 1) {
      this.finish();
      return;
    }

    this.index.update((i) => i + 1);
    this.pass();
  }

  finish() {
    this.finished.emit();
  }
}
